import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SmsWarningComponent } from './sms-warning.component';

@NgModule({
  declarations: [
    SmsWarningComponent
  ],
  imports: [CommonModule],
  exports: [SmsWarningComponent],
})
export class SmsWarningModule { }
